<template>
  <user-form @save="onSave" />
</template>

<script>
import UserForm from './Form.vue'

export default {
  components: { UserForm },
  methods: {
    onSave(users) {
      for (let i = 0; i < users.length; i++) {
        const user = {
          email: users[i].email,
          roleId: users[i].role,
        }
        this.$store
          .dispatch('projects/inviteUser', user)
          .then(() => {
            if (i === users.length - 1) {
              this.$router.push({ name: 'project-settings', query: { tab: 1 } })
            }
          })
          .catch(error => {
            this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while inviting users.')
          })
      }
    },
  },
}
</script>
